var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTransactionBgImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 124,
    height: 136,
    viewBox: "0 0 124 136",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4251_25901",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 124,
    height: 136
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 123.93,
    width: 136,
    height: 123.929,
    transform: "rotate(90 123.93 0)",
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4251_25901)"
  }, /*#__PURE__*/React.createElement("circle", {
    opacity: 0.1,
    cx: 115.683,
    cy: 19.5164,
    r: 115.68,
    transform: "rotate(90 115.683 19.5164)",
    fill: "#C8D2E1"
  }), /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.1,
    cx: 137.412,
    cy: 36.2108,
    rx: 65.5858,
    ry: 65.787,
    transform: "rotate(90 137.412 36.2108)",
    fill: "#869CBD"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransactionBgImage);
export default __webpack_public_path__ + "static/media/transaction-bg-image.ec754a4af179a2d9db785a82a446ac70.svg";
export { ForwardRef as ReactComponent };